import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 5,
	height: 5,
	viewBox: "0 0 5 5",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.11843 4.0133C2.94555 4.31273 2.51337 4.31273 2.34049 4.0133L0.784616 1.31844C0.611741 1.01901 0.827835 0.644728 1.17359 0.644728L4.28534 0.644728C4.63109 0.644728 4.84718 1.01901 4.67431 1.31844L3.11843 4.0133Z",
		fill: "#B2B4B9"
	})
});
export default SvgArrowDownFill;
